/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React from "react";
import {
  selectAdasProgramsState,
  setSensorBomVisibleSensorsCheckboxes,
  TCheckboxData
} from "../../../../../redux/ducks/AdasPrograms/slice";
import {useAppDispatch, useAppSelector} from "../../../../../redux/hooks";
import {EAdasProgramSensorBomCheckboxTypes} from "../types";
import ArgosFlexbox from "../../../../components/Containers/ArgosFlexbox";
import {getSensorIcon} from "../adasProgramsHelperFunctions";
import {Checkbox, FormControlLabel} from "@mui/material";
import BoxWithCenteredContent from "../../../../components/Containers/BoxWithCenteredContent";
import {VehicleImage} from "./VehicleImage";

export const SensorBillOfMaterialsLocationMap = React.memo((props: any) => { // React.memo so doesn't rerender every time outer does eg on collapse button press

  const checkboxes: TCheckboxData = useAppSelector(state => state.adasPrograms.sensorBom.sensorBomVisibleSensorsCheckboxes)
  const dispatch = useAppDispatch()
  const reduxSensorsFromDatabase: any = useAppSelector(state => selectAdasProgramsState(state)?.sensorBom?.sensorsFromDatabase)
  let checkboxKeys: EAdasProgramSensorBomCheckboxTypes[] = Object.keys(checkboxes) as EAdasProgramSensorBomCheckboxTypes[]
  checkboxKeys = checkboxKeys.filter((key: any) => {
    return key === EAdasProgramSensorBomCheckboxTypes.SENSOR_LOCATIONS || reduxSensorsFromDatabase?.[key]?.length > 0
  })

  return (
    <ArgosFlexbox style={{height: '100%', width: '100%', overflow: 'auto'}}>
      <div style={{alignSelf: 'center', display: 'flex', flexDirection: 'column', gap: 5}}>
        {checkboxKeys.map((checkboxKey: EAdasProgramSensorBomCheckboxTypes, index) => {
          // if (checkboxKey === ECheckboxData.LIDARS) return null
          const val = checkboxes[checkboxKey]
          const logo = getSensorIcon(checkboxKey)
          return (
            <div key={index} style={{display: 'flex', alignItems: 'center'}}>
              <FormControlLabel
                style={{margin: 0}}

                control={
                  <Checkbox
                    checked={val.checked}
                    onChange={(e) => {
                      const newVal = {...checkboxes, [checkboxKey]: {...val, checked: e.target.checked}}
                      dispatch(setSensorBomVisibleSensorsCheckboxes(newVal))
                    }}
                  />
                }
                label={checkboxKey}
              />
              <div style={{marginBottom: 5}}>{logo}</div>
            </div>
          )
        })}
      </div>
      <BoxWithCenteredContent
        // vertical
        horizontal
        style={{
          width: '100%', flex: 1, flexDirection: 'column', overflow: 'auto', height: 'auto'
          // paddingLeft: 10
        }}
      >
        <VehicleImage/>
      </BoxWithCenteredContent>
    </ArgosFlexbox>
  )
})